export class AcquireTokenTimedoutError extends Error {
  public name = 'AcquireTokenTimedoutError';

  constructor(...args: Parameters<ErrorConstructor>) {
    super(...args);
    Object.setPrototypeOf(this, AcquireTokenTimedoutError.prototype);
  }
}
